const originalWarn = console.warn;

console.warn = (...args) => {
  const msg = args[0];
  if (
    typeof msg === 'string' &&
    msg.includes('findDOMNode is deprecated')
  ) {
    return;
  }
  originalWarn(...args);
};
